import { createAction } from '@reduxjs/toolkit';

const authRoot = 'auth';
export const getUserInfo = createAction(`${authRoot}/getUserDetails`);
export const getUserInfoSuccess = createAction(`${authRoot}/getUserInfoSuccess`);
